import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_2 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_3 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_4 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row justify-start items-center gap-2"
}
const _hoisted_6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-row justify-start items-center gap-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#36B37E",
    "fill-rule": "evenodd",
    d: "M8 14.4c1.697 0 3.325-.674 4.525-1.874 1.2-1.2 1.875-2.829 1.875-4.526 0-1.697-.674-3.325-1.875-4.525C11.325 2.275 9.697 1.6 8 1.6c-1.697 0-3.325.674-4.526 1.875C2.274 4.675 1.6 6.303 1.6 8c0 1.697.674 3.325 1.874 4.526C4.674 13.726 6.303 14.4 8 14.4zm2.966-7.434c.145-.151.226-.353.224-.563-.002-.21-.086-.41-.234-.559-.149-.148-.35-.232-.559-.234-.21-.002-.412.079-.563.224L7.2 8.47 6.166 7.435c-.151-.146-.353-.227-.563-.225-.21.002-.41.086-.559.234-.148.149-.232.35-.234.559-.002.21.079.412.224.563l1.6 1.6c.15.15.354.234.566.234.212 0 .416-.084.566-.234l3.2-3.2z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_9 = { class: "text-green-lp-400 text-14px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    rounded: "xl",
    class: "flex flex-col px-3 pt-3 pb-1.5",
    isShadow: false
  }, {
    default: _withCtx(() => [
      (!_ctx.isSttAdjustClient && _ctx.formType === 'client')
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            id: "input_booking_shipment_id",
            label: _ctx.$t('bookingShipment.column.shipmentId'),
            class: "col-span-2 w-full",
            optional: "",
            tooltipDescription: _ctx.$t('bookingShipment.tooltip.shipmentId'),
            isDarkMode: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.modelValue.shipmentId,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.shipmentId = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.validateShipmentId(_ctx.modelValue.shipmentId, _ctx.modelValue)
        ))
                ],
                placeholder: _ctx.$t('bookingShipment.placeholder.shipmentId'),
                disabled: 
            !_ctx.flagEnableHandleSelectClientIdFromShipment &&
            !_ctx.modelValue.clientName.id
        ,
                disableBackground: 
          !_ctx.flagEnableHandleSelectClientIdFromShipment &&
          !_ctx.modelValue.clientName.id
        ,
                errorCaption: _ctx.$t(`${_ctx.errorShipmentIdMessage}`),
                error: !!_ctx.errorShipmentIdMessage,
                errorIcon: false,
                onKeydown: _ctx.onKeyDownShipmentId
              }, null, 8, ["modelValue", "placeholder", "disabled", "disableBackground", "errorCaption", "error", "onKeydown"])
            ]),
            _: 1
          }, 8, ["label", "tooltipDescription"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_1, [
        (_ctx.isSttAdjustRetail)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.$t('bookingShipment.column.paymentMethod'),
              class: "col-span-2 w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.modelValue.checkoutPaymentMethod,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.checkoutPaymentMethod = $event)),
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.isSttAdjustClient)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: _ctx.$t('bookingShipment.column.shipmentId'),
              class: "col-span-2 w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.modelValue.shipmentId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.shipmentId = $event)),
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          id: "input_booking_stt_manual",
          class: "w-full mr-4"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.sttManualReference.labelStt")) + " ", 1),
                _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("bookingV3.sttManualReference.labelOptional")), 1)
              ])
            ]),
            _createVNode(_component_lp_input, {
              class: "my-2",
              placeholder: _ctx.$t('bookingV3.sttManualReference.placeholderStt'),
              onChange: _cache[5] || (_cache[5] = 
            (value) => {
              _ctx.validateSttManual(value, _ctx.modelValue);
          }),
              modelValue: _ctx.modelValue.sttManual,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.sttManual = $event)),
              errorCaption: _ctx.$t(`${_ctx.errorSttMessage}`),
              error: _ctx.errorStt,
              errorIcon: false,
              disabled: _ctx.disabledSttManual,
              disableBackground: _ctx.disabledSttManual,
              onFocus: _ctx.setDirty
            }, null, 8, ["placeholder", "modelValue", "errorCaption", "error", "disabled", "disableBackground", "onFocus"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          id: "input_booking_no_ref_external",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.sttManualReference.labelReference")) + " ", 1),
                _withDirectives(_createVNode("span", { class: "text-gray-lp-500 font-normal" }, _toDisplayString(_ctx.$t("bookingV3.sttManualReference.labelOptional")), 513), [
                  [_vShow, !_ctx.isClientAndDo || _ctx.requiredRefExternal]
                ])
              ])
            ]),
            _createVNode(_component_lp_input, {
              placeholder: _ctx.$t('bookingV3.sttManualReference.placeholderReference'),
              modelValue: _ctx.modelValue.referenceExternal,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.referenceExternal = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (
            _ctx.validateRefNumber(
              _ctx.modelValue.referenceExternal,
              _ctx.isClientAndDo,
              _ctx.requiredRefExternal
            )
          ))
              ],
              errorCaption: _ctx.$t(`${_ctx.errorReferenceNumber}`),
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (
            _ctx.validateRefNumber(
              _ctx.modelValue.referenceExternal,
              _ctx.isClientAndDo,
              _ctx.requiredRefExternal
            )
          )),
              maxLength: 100,
              errorIcon: false,
              error: !_ctx.loadingSttRefExtCheck && _ctx.errorReference,
              disabled: _ctx.disabledRefExternal,
              disableBackground: _ctx.disabledRefExternal
            }, null, 8, ["placeholder", "modelValue", "errorCaption", "error", "disabled", "disableBackground"]),
            (_ctx.loadingSttRefExtCheck || _ctx.errorSystem)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock("svg", _hoisted_6, [
                    _createVNode("path", {
                      fill: _ctx.errorSystem ? '#B82025' : '#4D4D4D',
                      "fill-rule": "evenodd",
                      d: "M6.217 3.522c1.434-.837 3.105-1.175 4.751-.96 1.647.214 3.175.968 4.347 2.145 1.171 1.176 1.92 2.708 2.127 4.356.057.456-.266.873-.723.93-.457.058-.873-.266-.93-.722-.162-1.282-.744-2.473-1.655-3.388s-2.1-1.502-3.38-1.669c-1.281-.167-2.581.096-3.696.747-.737.43-1.366 1.014-1.847 1.706H7.5c.46 0 .833.373.833.833 0 .46-.373.833-.833.833H3.333c-.46 0-.833-.373-.833-.833V3.333c0-.46.373-.833.833-.833.46 0 .834.373.834.833v1.95c.567-.701 1.26-1.3 2.05-1.761zM3.28 10.007c.457-.058.874.265.932.722.162 1.28.744 2.471 1.655 3.386.912.914 2.1 1.501 3.38 1.668 1.28.166 2.58-.096 3.695-.747.737-.43 1.365-1.012 1.847-1.703H12.5c-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833h4.167c.46 0 .833.373.833.833v4.167c0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833v-1.952c-.567.702-1.26 1.3-2.05 1.76-1.434.837-3.105 1.175-4.75.96-1.646-.214-3.175-.968-4.346-2.144-1.172-1.175-1.92-2.706-2.129-4.353-.058-.457.266-.874.722-.931z",
                      "clip-rule": "evenodd"
                    }, null, 8, ["fill"])
                  ])),
                  _createVNode("span", {
                    class: 
              `${
                _ctx.errorSystem ? 'text-red-lp-1200' : 'text-gray-lp-300'
              } text-14px`
            
                  }, _toDisplayString(_ctx.errorSystem
                ? _ctx.$t("bookingV3.sttManualReference.error.refExtFailedSystem")
                : _ctx.$t("bookingV3.sttManualReference.checkStt")), 3)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSuccessCheckStt)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("bookingV3.sttManualReference.success.sttApproved")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}